import React from "react";
import {
  MISSING_TENANT_MESSAGE_COMPANY,
  MISSING_TENANT_MESSAGE_LINE1,
  MISSING_TENANT_MESSAGE_LINE2_PREFIX,
} from "../constants/Defaults.constants";

export const DARK_MATTER_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/dark-matter-logo.svg`;

const MESSAGE_MAX_WIDTH = 720;

/**
 * Invalid / missing ?co= tenant — shown before app shell (no theme required).
 */
const MissingTenantNotice = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      maxWidth: MESSAGE_MAX_WIDTH,
      margin: "0 auto",
      padding: "0 24px",
      boxSizing: "border-box",
    }}
  >
    <img
      src={DARK_MATTER_LOGO_SRC}
      alt="Dark Matter Technologies"
      style={{
        display: "block",
        width: "auto",
        height: "auto",
        maxWidth: 180,
        maxHeight: 72,
        marginBottom: 24,
      }}
    />
    <p
      style={{
        margin: 0,
        fontSize: "1.25rem",
        lineHeight: 1.5,
        textAlign: "center",
        width: "100%",
        maxWidth: MESSAGE_MAX_WIDTH,
      }}
    >
      {MISSING_TENANT_MESSAGE_LINE1}
      <br />
      <span style={{ whiteSpace: "nowrap" }}>
        {MISSING_TENANT_MESSAGE_LINE2_PREFIX}
        {MISSING_TENANT_MESSAGE_COMPANY}
      </span>
    </p>
  </div>
);

export default MissingTenantNotice;
